export interface TranslationUpdate {
  id: number;
  translation: string;
}

export interface SegmentWithTranslation {
  id: number;
  translation?: string;
}

export function applyTranslationUpdates<T extends SegmentWithTranslation>(
  segments: T[],
  updates: TranslationUpdate[],
  indexById?: ReadonlyMap<number, number>
): T[] {
  if (segments.length === 0 || updates.length === 0) return segments;

  if (indexById && indexById.size > 0) {
    let nextSegments = segments;
    for (const update of updates) {
      const index = indexById.get(update.id);
      if (index === undefined) continue;
      const current = nextSegments[index];
      if (!current) continue;
      if (current.translation === update.translation) continue;
      if (nextSegments === segments) {
        nextSegments = segments.slice();
      }
      nextSegments[index] = { ...current, translation: update.translation };
    }
    return nextSegments;
  }

  const updatesById = new Map(updates.map((u) => [u.id, u.translation]));
  let changed = false;

  const nextSegments = segments.map((segment) => {
    const translation = updatesById.get(segment.id);
    if (translation === undefined || translation === segment.translation) return segment;
    changed = true;
    return { ...segment, translation };
  });

  return changed ? nextSegments : segments;
}

